export const NARRATORS = ["af", "bm"] as const;

export type Narrator = (typeof NARRATORS)[number];

/** Narrator values that older builds and old rows may still hold. */
export type LegacyNarrator = Narrator | "am" | "bf";

export const DEFAULT_NARRATOR: Narrator = "af";

export type NarratorOption = {
  value: Narrator;
  flag: string;
  title: string;
  /** The Spoola voice that narrates articles for this narrator. */
  spoolaVoice: string;
};

export const NARRATOR_OPTIONS: NarratorOption[] = [
  { value: "af", flag: "🇺🇸", title: "American Female", spoolaVoice: "heart" },
  { value: "bm", flag: "🇬🇧", title: "British Male", spoolaVoice: "george" },
];

export const NARRATOR_LABELS: Record<Narrator, string> = {
  af: "American Female",
  bm: "British Male",
};

export const SPOOLA_VOICES: Record<Narrator, string> = {
  af: "heart",
  bm: "george",
};

/** Stored `am` becomes `bm` and `bf` becomes `af`, keeping the gender. */
const LEGACY_NARRATORS: Record<LegacyNarrator, Narrator> = {
  af: "af",
  bm: "bm",
  am: "bm",
  bf: "af",
};

export const isNarrator = (value: unknown): value is Narrator => {
  return typeof value === "string" && (NARRATORS as readonly string[]).includes(value);
};

/** Maps any stored narrator value to a current one; unknown values fall back to the default. */
export const normalizeNarrator = (value: string | undefined | null): Narrator => {
  return LEGACY_NARRATORS[value as LegacyNarrator] ?? DEFAULT_NARRATOR;
};
